import { Record } from 'immutable';

export interface IPoint {
  x?: number;
  y?: number;
}

export type Point = Record<IPoint>;
// Record returns a class type, which creates a runtime variable and identifier in the namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Point = Record<IPoint>({ x: undefined, y: undefined }, 'Point');

export const PointMarshaller = {
  deserialize: (pointData: IPoint) => new Point(pointData),
  serialize: (point: Point) => point.toJSON(),
};
